import Tooltip from './tooltip.component';
export default Tooltip;
